module.exports = __webpack_public_path__ + "202408221624/img/home_case_1.4e92a70b.jpg";